import styled from "styled-components"

export const Wrapper = styled.div`
    margin: auto auto -20px auto;
    padding: 0 20px;
    color: var(--white);
`

export const Content = styled.div`
    margin: 0 auto;
    display: flex;
    align-items: left;
    vertical-align: top;
    flex-direction: column;
    justify-content: space-around;
`

export const ButtonWrapper = styled.div`
    padding: 20px 20px;
    width: 300px;
    display: flex;
    align-items: left;
    vertical-align: top;
    flex-direction: column;
    justify-content: space-around;
`